import {
    PostStatDto,
    PostStatItem,
    PostStatItemDto,
    PostStatModel,
} from '../../data-layer/posts/types';

const getStatItem = (businessStatItemDto: PostStatItemDto): PostStatItem => ({
    value: businessStatItemDto.value,
    display: businessStatItemDto.display,
    diffValue: businessStatItemDto.diff_value,
    diffDisplay: businessStatItemDto.diff_display,
});

export const toPostStatisticModel = (postStatDto: PostStatDto): PostStatModel => ({
    coverage: {
        total: getStatItem(postStatDto.coverage.total),
        subscribers: getStatItem(postStatDto.coverage.subscribers),
        notsubscribers: getStatItem(postStatDto.coverage.notsubscribers),
        boosted: postStatDto.coverage.boosted && getStatItem(postStatDto.coverage.boosted),
        organic: postStatDto.coverage.organic && getStatItem(postStatDto.coverage.organic),
    },
    involved: {
        total: getStatItem(postStatDto.involved.total),
        subscribers: getStatItem(postStatDto.involved.subscribers),
        notsubscribers: getStatItem(postStatDto.involved.notsubscribers),
        boosted: postStatDto.involved.boosted && getStatItem(postStatDto.involved.boosted),
        organic: postStatDto.involved.organic && getStatItem(postStatDto.involved.organic),
    },
    shows: {
        total: getStatItem(postStatDto.shows.total),
        subscribers: getStatItem(postStatDto.shows.subscribers),
        notsubscribers: getStatItem(postStatDto.shows.notsubscribers),
        boosted: postStatDto.shows.boosted && getStatItem(postStatDto.shows.boosted),
        organic: postStatDto.shows.organic && getStatItem(postStatDto.shows.organic),
    },
    showsInGrid: {
        total: getStatItem(postStatDto.shows_in_grid.total),
        subscribers: getStatItem(postStatDto.shows_in_grid.subscribers),
        notsubscribers: getStatItem(postStatDto.shows_in_grid.notsubscribers),
        boosted:
            postStatDto.shows_in_grid.boosted && getStatItem(postStatDto.shows_in_grid.boosted),
        organic:
            postStatDto.shows_in_grid.organic && getStatItem(postStatDto.shows_in_grid.organic),
    },
    subscribers: {
        total: getStatItem(postStatDto.subscribers.total),
        subscribed: getStatItem(postStatDto.subscribers.subscribed),
        unsubscribed: getStatItem(postStatDto.subscribers.unsubscribed),
    },
    interactions: {
        total: getStatItem(postStatDto.interactions.total),
        clicks: getStatItem(postStatDto.interactions.clicks),
        likes: getStatItem(postStatDto.interactions.likes),
        shares: getStatItem(postStatDto.interactions.shares),
        saves: getStatItem(postStatDto.interactions.saves),
    },
    clicks: postStatDto.clicks && {
        total: getStatItem(postStatDto.clicks.total),
        subscribers: getStatItem(postStatDto.clicks.subscribers),
        notsubscribers: getStatItem(postStatDto.clicks.notsubscribers),
        boosted: postStatDto.clicks.boosted && getStatItem(postStatDto.clicks.boosted),
        organic: postStatDto.clicks.organic && getStatItem(postStatDto.clicks.organic),
    },
});
